import Card from "@/components/shared-ui/Card";
import ContactCard from "@/components/shared-ui/ContactCard";
import useCompany from "@/contexts/CompanyContext";
import { useAuth0 } from "@auth0/auth0-react";
import WelcomeCard from "../WelcomeCards/WelcomeCard";
import HubHighlights from "../HubHighlights";
import TrainingCard from "../TrainingCard";
import OnboardingCard from "../OnboardingCard";
import useOnrampProject from "@/hooks/useOnrampProjects";

const DashboardCustomers = () => {
  const { user } = useAuth0();
  const { companyName, companyStatus } = useCompany();

  const rawRoles = user?.["https://customer.seccl.tech/roles"];
  const roles: string[] = Array.isArray(rawRoles) ? rawRoles : [];
  const isFullUser = roles.includes("all_features");

  const isOnboarding = companyStatus === "onboarding";
  const isLive = companyStatus === "live";
  const isIntegration = companyStatus === "integration";
  const canAccessOnramp = (isLive || isOnboarding) && isFullUser;
  const { data: onboardingProjects, isPending } =
    useOnrampProject(canAccessOnramp);

  const hasNoOnrampProject =
    !isPending && onboardingProjects?.length === 0;

  return (
    <>
      <Card
        gridColumn="1 / -1"
        noPadding
        featureBackground={{ full: true, gradient: "light2" }}
      >
        <WelcomeCard companyName={companyName} />
      </Card>

      {(isLive || isOnboarding || isIntegration) && <HubHighlights />}
      {(isLive || isOnboarding || isIntegration) && <TrainingCard />}

      {canAccessOnramp && !hasNoOnrampProject && (
        <OnboardingCard canAccessOnramp={canAccessOnramp} />
      )}
      <ContactCard />
    </>
  );
};

export default DashboardCustomers;
